import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CONTACT, SITE } from '../config';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const openCookies = () => {
    // @ts-ignore
    if (window.openCookieSettings) {
      // @ts-ignore
      window.openCookieSettings();
    }
  };

  return (
    <footer className="bg-[#2c1b1b] text-white/80 pt-12 md:pt-16 pb-6 md:pb-8 mt-auto w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-10 md:mb-12">
          {/* Brand */}
          <div className="space-y-3 sm:space-y-4">
            <h3 className="text-xl sm:text-2xl font-bold text-white font-serif">Chalupa Laura</h3>
            <p className="text-xs sm:text-sm leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
          </div>

          {/* Links */}
          <div className="space-y-3 sm:space-y-4">
            <h4 className="text-white font-semibold text-base sm:text-lg">{t('footer.links')}</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/rezervace" className="hover:text-white transition-colors">{t('nav.reservation')}</Link></li>
              <li><Link to="/galerie" className="hover:text-white transition-colors">{t('nav.gallery')}</Link></li>
              <li><Link to="/information" className="hover:text-white transition-colors">{t('nav.information')}</Link></li>
              <li><Link to="/kontakt" className="hover:text-white transition-colors">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact & Legal */}
          <div className="space-y-3 sm:space-y-4">
            <h4 className="text-white font-semibold text-base sm:text-lg">{t('footer.contact')}</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>{CONTACT.address}</li>
              <li><a href={CONTACT.phoneLink} className="hover:text-white transition-colors">{CONTACT.phone}</a></li>
              <li><a href={CONTACT.emailLink} className="hover:text-white transition-colors">{CONTACT.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-[11px] sm:text-xs">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 text-center md:text-left">
            <span>© {currentYear} Chalupa Laura. {t('footer.rights')}</span>
            <button
              onClick={openCookies}
              className="hover:text-white underline decoration-white/30 underline-offset-4 transition-colors"
            >
              {t('footer.cookies')}
            </button>
          </div>
          
          <div className="flex items-center gap-1">
            {t('footer.createdBy')} 
            <a 
              href="https://halvion-group.cz/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-semibold text-white hover:text-[#A9745B] transition-colors ml-1"
            >
              Halvion Group
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
